import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tool-people",
  "use": "tool-people-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 16 16\" id=\"tool-people\">\r\n<path d=\"M1.445 13.85l0.006-0.018 0.005-0.019c0.594-2.461 2.603-4.166 4.863-4.166 2.257 0 4.278 1.704 4.963 4.187 0.19 0.697-0.27 0.99-0.448 0.99h-8.935c-0.074 0-0.226-0.054-0.356-0.26-0.123-0.194-0.174-0.454-0.097-0.714zM9.375 4.235c0 1.681-1.377 3.059-3.056 3.059s-3.056-1.378-3.056-3.059c0-1.681 1.377-3.059 3.056-3.059s3.056 1.378 3.056 3.059z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol